import React from 'react';
import SvgIcon from 'e100-react-components/lib/components/SvgIcon';
import { IProps } from 'e100-react-components/lib/components/SvgIcon/index';

export const EventOutlined = (props: IProps) => (
  <SvgIcon {...props}>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M18 3H19C20.11 3 21 3.9 21 5V19C21 20.11 20.11 21 19 21H5C3.9 21 3 20.11 3 19V5C3 3.9 3.89 3 5 3H6V1H8V3H16V1H18V3ZM5 19H19V9H5V19ZM5 7H19V5H5V7ZM17 13H13V17H17V13Z" />
  </SvgIcon>
);
